import React from "react";
import styles from "./InnerTable.module.scss";
import Icon from "../../../../components/Icon";

const InnerTableComponent = ({ cells, colorKey }) => {
  return (
    <table className={styles.table}>
      <tbody>
        <tr>
          {cells.length > 0 ? (
            cells.map((cell, index) => (
              <td
                className={styles.td}
                key={index}
                style={{
                  backgroundColor: colorKey
                    ? typeof colorKey === "string"
                      ? colorKey
                      : colorKey[cell]
                    : null
                }}
              >
                {cell ? (
                  <div className={styles.cell}>
                    <span>{cell}</span>
                  </div>
                ) : (
                  "\u00A0"
                )}
              </td>
            ))
          ) : (
            <td
              style={{
                backgroundColor: colorKey
                  ? typeof colorKey === "string"
                    ? colorKey
                    : null
                  : null
              }}
            >
              &nbsp;
            </td>
          )}
        </tr>
      </tbody>
    </table>
  );
};

export default InnerTableComponent;
